import { app } from '../../../../app';

app.component('companyManageApplicationUsageData', {
    bindings: {application: '<'},
    templateUrl: require('./usage-data.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/usage-data/usage-data.component.js